import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { ReactComponent as CloseIcon } from "../../../assets/icons/modal/close.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/modal/delete.svg";
import { ReactComponent as EditModalIcon } from "../../../assets/icons/modal/warehouse.svg";
import { IBatchCreateDto } from "../../../types/batch.type";
import { IProduct } from "../../../types/product.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import ModalDeleteButtons from "../forms/buttons/ModalDeletButtons/ModalDeleteButtons";
import ViewWarehouseForm from "../forms/EditWarehouseForm/ViewWarehouseForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  warehouse: IProduct;
  onClose: () => void;
  onApply: () => void;
  isInfo: boolean;
}

const EditWarehouseModal: React.FC<Props> = (props) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  const onPressApply = async () => {
    props.onApply();
    props.onClose();
  };

  const onPressApplyUpdate = async (id: string, body: IBatchCreateDto[]) => {
    try {
      // const response = await authApiService.createBatch(body);
      // if (response) {
      //   onPressApply();
      // }
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const onPressDelete = async () => {
    try {
      // const response = await authApiService.deleteWarehouse(props.warehouse.id);
      // if (response) {
      //   props.onApply();
      //   props.onClose();
      // }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <DefaultModal>
      <div className={styles.container}>
        {isDelete ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Підтвердіть видалення ресурсу зі складу"
              subTitle="Ви дійсно хочете видалити цей ресурс? Цю дію неможливо скасувати."
            >
              <DeleteIcon />
            </ModalTitle>
            <ModalDeleteButtons
              onPressApply={onPressDelete}
              onPressBack={() => {
                setIsDelete(false);
              }}
              applyTitle="Видалити"
              backTitle="Назад"
            />
          </>
        ) : isEdit ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Редагувати ресурс"
              subTitle='Редагуйте інформацію про ресурс на складі. Внесіть необхідні зміни та натисніть "Зберегти" для оновлення даних.'
            >
              <EditModalIcon />
            </ModalTitle>
            {/* <EditWarehouseForm
              onClose={() => props.onClose()}
              item={props.warehouse}
              onApply={onPressApplyUpdate}
            /> */}
          </>
        ) : (
          <>
            <div className={styles.header}>
              <div className={styles.upSide}>
                {props.warehouse.previewImageUrl ? (
                  <img
                    src={props.warehouse.previewImageUrl}
                    alt="Avatar"
                    className={styles.avatar}
                  />
                ) : (
                  <div />
                )}
                <button className={styles.upSideButton} onClick={props.onClose}>
                  <CloseIcon />
                </button>
              </div>
              <div className={styles.nameContainer}>
                <span className={styles.name}>{props.warehouse.name}</span>
              </div>
            </div>
            <ViewWarehouseForm
              warehouse={props.warehouse}
              onClose={props.onClose}
              onPressEdit={() => {
                props.onApply();
              }}
            />
          </>
        )}
      </div>
    </DefaultModal>
  );
};

export default EditWarehouseModal;
